import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ArticleIcon from "@mui/icons-material/Article";
import { Button, Link, TextField } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { GridCloseIcon } from "@mui/x-data-grid/components/icons";
import React, { useState } from "react";
import SlidingPanel from "react-sliding-side-panel";
import CheckBox from "../../../../Supporting files/CheckBox/CheckBox";
import DatePicker from "../../../../Supporting files/DatePicker/DatePicker";
import RKTextField from "../../../../Supporting files/RKTextField/RKTextField";
import SearchDropdown from "../../../../Supporting files/SearchDropdown/SearchDropdown";
import SelectDropdown from "../../../../Supporting files/SelectDropdown/SelectDropdown";
import TextArea from "../../../../Supporting files/TextArea/TextArea";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
  client_id_status: boolean;
}

const InitiateAClaim: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
  client_id_status,
}) => {
  const [pageStatus, setPageStatus] = React.useState<number>(1);
  const [insurer, setInsurer] = React.useState("Reliance General Insurance ");
  const [claimForm, setClaimForm] = React.useState("");
  const [policy, setPolicy] = React.useState("");
  const [clientid, setClientId] = React.useState("");
  const [employeeid, setEmployeeId] = React.useState("");
  const [insuredPersonHospitalized, setInsuredPersonHospitalized] =
    React.useState("Uday Kumar");
  const [country, setCountry] = React.useState("");
  const [state, setState] = React.useState("");
  const [hospitalName, setHospitalName] = React.useState("");
  const [city, setCity] = React.useState("");
  const [admissionDate, setAdmissionDate] = React.useState<Date | null>(null);
  const [dischargeDate, setDischargeDate] = React.useState<Date | null>(null);
  const [claimAmount, setClaimAmount] = useState("");
  const [reasonForHospitalization, setReasonForHospitalization] =
    React.useState("");
  const [attachFir, setAttachFir] = React.useState(false);
  const [kycDocumentStatus, setKycDocumentStatus] = React.useState("kyc");
  const [documentStatus, setDocumentStatus] = React.useState(0);
  const [addDocumentField, setAddDocumentField] = useState<
    Array<{ add_field: string }>
  >([{ add_field: "" }]);
  const [file, setFile] = useState();

  function handleChange(event: any) {
    setFile(event.target.files[0]);
  }

  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };
  const client_id_data = [
    { label: "CLID3232-Evervent", value: "CLID3232-Evervent" },
    { label: "CLID3233-Evervent", value: "CLID3233-Evervent" },
    { label: "CLID3234-Evervent", value: "CLID3234-Evervent" },
    { label: "CLID3235-Evervent", value: "CLID3235-Evervent" },
    { label: "CLID3236-Evervent", value: "CLID3236-Evervent" },
    { label: "CLID3237-Evervent", value: "CLID3237-Evervent" },
  ];
  const employee_id_data = [
    { label: "EV 3232-Uday Kumar", value: "EV 3232-Uday Kumar" },
    { label: "EV 3233-Uday Kumar", value: "EV 3233-Uday Kumar" },
    { label: "EV 3234-Uday Kumar", value: "EV 3234-Uday Kumar" },
    { label: "EV 3235-Uday Kumar", value: "EV 3235-Uday Kumar" },
    { label: "EV 3236-Uday Kumar", value: "EV 3236-Uday Kumar" },
    { label: "EV 3237-Uday Kumar", value: "EV 3237-Uday Kumar" },
  ];
  const policy_data = [
    { label: "PB 1562-Group Health", value: "PB 1562-Group Health" },
    { label: "PB 1563-Group Health", value: "PB 1563-Group Health" },
    { label: "PB 1564-Group Health", value: "PB 1564-Group Health" },
    { label: "PB 1565-Group Health", value: "PB 1565-Group Health" },
    { label: "PB 1566-Group Health", value: "PB 1566-Group Health" },
  ];

  const country_data = [
    { label: "India", value: "India" },
    { label: "England", value: "England" },
    { label: "Australia", value: "Australia" },
    { label: "New Zealand", value: "New Zealand" },
  ];
  const state_data = [
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Delhi ", value: "Delhi" },
    { label: "Himachal pradesh", value: "Himachal pradesh" },
    { label: "Haryana", value: "Haryana" },
    { label: "Punjab", value: "Punjab" },
  ];
  const city_data = [
    { label: "Mohali", value: "Mohali" },
    { label: "Shimla ", value: "Shimla" },
    { label: "Dharamshala", value: "Dharamshala" },
    { label: "Panchkula", value: "Panchkula" },
  ];
  const claim_data = [
    { key: "GroupHealthForm", value: "Group Health Form" },
    { key: "GroupTermForm", value: "Group Term Form" },
    { key: "GroupTravelForm", value: "Group Travel Form" },
  ];

  const changePageStatus = (status: boolean) => {
    if (status === true) {
      if (pageStatus < 2) {
        setPageStatus(pageStatus + 1);
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  };

  //   const updateMasterStateArray = (attrName: any, value: any) => {
  //     const array_data = [...addCategoryStep];
  //     if (attrName[1] === "category_name") {
  //       array_data[attrName[0]].category_name = value;
  //     } else if (attrName[1] === "description") {
  //       array_data[attrName[0]].description = value;
  //     }

  //     setAddCategoryStep(array_data);
  //   };

  return (
    <SlidingPanel
      type={"right"}
      isOpen={open_status}
      size={75}
      panelClassName="sliding-panel"
      // backdropClicked={() => value_update(attrName, false)}
    >
      <div>
        <Grid container spacing={3} alignItems="center">
          <Grid xs={10}>
            <h4 className="mb-0 mt-3">Initiate a Claim</h4>
          </Grid>
          <Grid xs={2} textAlign="end" className="mt-3">
            <GridCloseIcon
              onClick={() => {
                value_update(attrName, false);
              }}
            />
          </Grid>
          <Grid xs={12} className="pt-0">
            <hr />
          </Grid>
        </Grid>
        <div className="scrollable_area">
          {pageStatus == 1 ? (
            <div>
              <Grid container spacing={2} className="mb-2 mt-4">
                <Grid xs={12}>
                  <div className="selector width-per-item">
                    <Button
                      className={kycDocumentStatus === "kyc" ? "selection" : ""}
                      style={{ color: "#000" }}
                      onClick={() => {
                        setKycDocumentStatus("kyc");
                        setDocumentStatus(0);
                      }}
                    >
                      <ArticleIcon /> Claim Intimation
                    </Button>
                    <Button
                      className={
                        kycDocumentStatus === "policy" ? "selection" : ""
                      }
                      style={{ color: "#000" }}
                      onClick={() => {
                        setKycDocumentStatus("policy");
                        setDocumentStatus(1);
                      }}
                    >
                      <AccountBalanceWalletIcon /> Cashless Request
                    </Button>
                  </div>
                  <p className="small-text">
                    Use Cashless Request for planned hospitalisation where bills
                    are settled directly by Insurer.
                  </p>
                </Grid>
                {/* {client_id_status == true ? (
                <Grid xs={4}>
                  <SelectDropdown
                    class_name="inputField"
                    title="Client ID"
                    value={clientid}
                    attrName={setClientId}
                    value_update={updateMasterState}
                    dropdown_data={client_id_data}
                    warn_status={false}
                  />
                </Grid>
                ) : null} */}
                <Grid xs={6}>
                  <SearchDropdown
                    class_name="inputField"
                    title="Client ID"
                    value={clientid}
                    attrName={setClientId}
                    value_update={updateMasterState}
                    data={client_id_data}
                    warn_status={false}
                    error_message={"please select client ID"}
                  />
                </Grid>
                <Grid xs={6}>
                  <SearchDropdown
                    class_name="inputField"
                    title="Member ID"
                    value={employeeid}
                    attrName={setEmployeeId}
                    value_update={updateMasterState}
                    data={employee_id_data}
                    warn_status={false}
                    error_message={"please select employee ID"}
                  />
                </Grid>
                <Grid xs={6}>
                  <SearchDropdown
                    class_name="inputField"
                    title="Select Policy"
                    value={policy}
                    attrName={setPolicy}
                    value_update={updateMasterState}
                    data={policy_data}
                    warn_status={false}
                    error_message={"please select policy"}
                  />
                </Grid>
                <Grid xs={6}>
                  <RKTextField
                    class_name="inputField"
                    title="Insurer"
                    value={insurer}
                    attrName={setInsurer}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <SelectDropdown
                    class_name="inputField"
                    title="Select Physical Claim form"
                    value={claimForm}
                    attrName={setClaimForm}
                    value_update={updateMasterState}
                    dropdown_data={claim_data}
                    warn_status={false}
                  />
                </Grid>
                {claimForm === "GroupHealthForm" ||
                claimForm === "GroupTermForm" ||
                claimForm === "GroupTravelForm" ? (
                  <Grid
                    xs={6}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Link
                      className="blueBtn download ml-0"
                      sx={{ textDecoration: "none", cursor: "pointer" }}
                    >
                      Download
                    </Link>
                  </Grid>
                ) : null}
                <Grid xs={6}>
                  <RKTextField
                    class_name="inputField"
                    title="Insured Person Hospitalized"
                    value={insuredPersonHospitalized}
                    attrName={setInsuredPersonHospitalized}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <SearchDropdown
                    class_name="inputField"
                    title="Country"
                    value={country}
                    attrName={setCountry}
                    value_update={updateMasterState}
                    data={country_data}
                    warn_status={false}
                    error_message={"please Select Country"}
                  />
                </Grid>
                <Grid xs={6}>
                  <SearchDropdown
                    class_name="inputField"
                    title="State"
                    value={state}
                    attrName={setState}
                    value_update={updateMasterState}
                    data={state_data}
                    warn_status={false}
                    error_message={"please Select State"}
                  />
                </Grid>
                <Grid xs={6}>
                  <SearchDropdown
                    class_name="inputField"
                    title="City"
                    value={city}
                    attrName={setCity}
                    value_update={updateMasterState}
                    data={city_data}
                    warn_status={false}
                    error_message={"please Select city"}
                  />
                </Grid>
                <Grid xs={6}>
                  <RKTextField
                    class_name="inputField"
                    title="Requested Claim Amount"
                    value={claimAmount}
                    attrName={setClaimAmount}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>

                {documentStatus === 0 ? (
                  <>
                    <Grid xs={6}>
                      <RKTextField
                        class_name="inputField"
                        title={"Hospital Name"}
                        value={hospitalName}
                        attrName={setHospitalName}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={6}>
                      <DatePicker
                        class_name="inputField"
                        title="Admission Date"
                        value={admissionDate}
                        attrName={setAdmissionDate}
                        value_update={updateMasterState}
                        error_message="Please enter admission date"
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={6}>
                      <DatePicker
                        class_name="inputField"
                        title="Discharge Date"
                        value={dischargeDate}
                        attrName={setDischargeDate}
                        value_update={updateMasterState}
                        error_message="Please enter admission date"
                        warn_status={false}
                      />
                    </Grid>
                  </>
                ) : null}
                {documentStatus === 1 ? (
                  <>
                    <Grid xs={6}>
                      <RKTextField
                        class_name="inputField"
                        title={"Hospital Name"}
                        value={hospitalName}
                        attrName={setHospitalName}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={6}>
                      <DatePicker
                        class_name="inputField"
                        title="Admission Date"
                        value={admissionDate}
                        attrName={setAdmissionDate}
                        value_update={updateMasterState}
                        error_message="Please enter admission date"
                        warn_status={false}
                      />
                    </Grid>
                  </>
                ) : null}

                <Grid xs={12}>
                  <TextArea
                    class_name="inputField multiline"
                    title={"Reason For Hospitalization"}
                    value={reasonForHospitalization}
                    attrName={setReasonForHospitalization}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
                {documentStatus === 0 ? (
                  <Grid xs={12}>
                    <CheckBox
                      title="If it is a legal case, you must attach the FIR as well."
                      name="regAddress"
                      id="regAddress"
                      value={attachFir}
                      attrName={setAttachFir}
                      value_update={updateMasterState}
                      default_check={false}
                    />
                  </Grid>
                ) : null}
                {attachFir === true ? (
                  <>
                    <Grid
                      xs={10}
                      className="inputField uploadFile"
                      paddingRight={0}
                    >
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        label=""
                        variant="outlined"
                        className="textarea"
                        placeholder="Upload document"
                      />
                    </Grid>
                    <Grid xs={2} paddingLeft={0}>
                      <Button
                        variant="contained"
                        className="browsebtn"
                        component="label"
                      >
                        Browse
                        <input
                          hidden
                          accept="image/*"
                          multiple
                          type="file"
                          onChange={handleChange}
                        />
                      </Button>
                    </Grid>
                  </>
                ) : null}

                <Grid xs={12}>
                  <p className="note_text">
                    Note:- Attach all the original hospital bills, from the
                    admission date till the date of filing the claim.
                  </p>
                </Grid>

                {addDocumentField.map((data, index) => (
                  <>
                    <Grid
                      xs={8}
                      className="inputField uploadFile"
                      paddingRight={0}
                    >
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        label=""
                        variant="outlined"
                        className="textarea"
                        placeholder="Upload document"
                      />
                    </Grid>
                    <Grid xs={2} paddingLeft={0}>
                      <Button
                        variant="contained"
                        className="browsebtn"
                        component="label"
                      >
                        Browse
                        <input
                          hidden
                          accept="image/*"
                          multiple
                          type="file"
                          onChange={handleChange}
                        />
                      </Button>
                    </Grid>
                  </>
                ))}

                <Grid
                  xs={2}
                  paddingLeft={0}
                  alignSelf={"center"}
                  textAlign={"center"}
                >
                  <Link
                    className="blueBtn addfile ml-0"
                    sx={{ textDecoration: "none", cursor: "pointer" }}
                    onClick={() => {
                      setAddDocumentField((addDocumentField) => [
                        ...addDocumentField,
                        {
                          add_field: "sdf",
                        },
                      ]);
                    }}
                  >
                    Add
                  </Link>
                </Grid>
              </Grid>
            </div>
          ) : pageStatus == 2 ? (
            <Grid
              container
              spacing={2}
              sx={{
                displau: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
              }}
            >
              <Grid xs={12}>
                <svg
                  className="checkmark"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 52 52"
                >
                  <circle
                    className="checkmark__circle"
                    cx="26"
                    cy="26"
                    r="25"
                    fill="none"
                  />
                  <path
                    className="checkmark__check"
                    fill="none"
                    d="M14.1 27.2l7.1 7.2 16.7-16.8"
                  />
                </svg>
                <p className="quote_success text-center">
                  New request has been submitted successfully!
                </p>
              </Grid>
            </Grid>
          ) : null}
        </div>
        {pageStatus !== 4 ? (
          <Grid container spacing={3}>
            <Grid xs={12} className="ctaBtn mt-4">
              <Button
                variant="contained"
                className="submitBtn fixedbtn"
                onClick={() => {
                  setPageStatus(pageStatus + 1);
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        ) : null}
      </div>
    </SlidingPanel>
  );
};

export default InitiateAClaim;
